"use strict";

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addLegacySimulcast = exports.getRtpEncodings = void 0;

function getRtpEncodings(_ref) {
  var offerMediaObject = _ref.offerMediaObject,
      track = _ref.track;
  // First media SSRC (or the only one).
  var firstSsrc;
  var ssrcs = new Set();

  var _iterator = _createForOfIteratorHelper(offerMediaObject.ssrcs || []),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var line = _step.value;

      if (line.attribute !== 'msid') {
        continue;
      }

      var trackId = line.value.split(' ')[1];

      if (trackId === track.id) {
        var ssrc = line.id;
        ssrcs.add(ssrc);

        if (!firstSsrc) {
          firstSsrc = ssrc;
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (ssrcs.size === 0) {
    throw new Error("a=ssrc line with msid information not found [track.id:".concat(track.id, "]"));
  }

  var ssrcToRtxSsrc = new Map(); // First assume RTX is used.

  var _iterator2 = _createForOfIteratorHelper(offerMediaObject.ssrcGroups || []),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _line = _step2.value;

      if (_line.semantics !== 'FID') {
        continue;
      }

      var _line$ssrcs$split = _line.ssrcs.split(/\s+/),
          _line$ssrcs$split2 = _slicedToArray(_line$ssrcs$split, 2),
          _ssrc = _line$ssrcs$split2[0],
          rtxSsrc = _line$ssrcs$split2[1];

      _ssrc = Number(_ssrc);
      rtxSsrc = Number(rtxSsrc);

      if (ssrcs.has(_ssrc)) {
        // Remove both the SSRC and RTX SSRC from the set so later we know that they
        // are already handled.
        ssrcs.delete(_ssrc);
        ssrcs.delete(rtxSsrc); // Add to the map.

        ssrcToRtxSsrc.set(_ssrc, rtxSsrc);
      }
    } // If the set of SSRCs is not empty it means that RTX is not being used, so take
    // media SSRCs from there.

  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var _iterator3 = _createForOfIteratorHelper(ssrcs),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _ssrc2 = _step3.value;
      // Add to the map.
      ssrcToRtxSsrc.set(_ssrc2, null);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  var encodings = [];

  var _iterator4 = _createForOfIteratorHelper(ssrcToRtxSsrc),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _step4$value = _slicedToArray(_step4.value, 2),
          _ssrc3 = _step4$value[0],
          _rtxSsrc = _step4$value[1];

      var encoding = {
        ssrc: _ssrc3
      };

      if (_rtxSsrc) {
        encoding.rtx = {
          ssrc: _rtxSsrc
        };
      }

      encodings.push(encoding);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return encodings;
}

exports.getRtpEncodings = getRtpEncodings;
/**
 * Adds multi-ssrc based simulcast into the given SDP media section offer.
 */

function addLegacySimulcast(_ref2) {
  var offerMediaObject = _ref2.offerMediaObject,
      track = _ref2.track,
      numStreams = _ref2.numStreams;

  if (numStreams <= 1) {
    throw new TypeError('numStreams must be greater than 1');
  }

  var firstSsrc;
  var firstRtxSsrc;
  var streamId; // Get the SSRC.

  var ssrcMsidLine = (offerMediaObject.ssrcs || []).find(function (line) {
    if (line.attribute !== 'msid') {
      return false;
    }

    var trackId = line.value.split(' ')[1];

    if (trackId === track.id) {
      firstSsrc = line.id;
      streamId = line.value.split(' ')[0];
      return true;
    } else {
      return false;
    }
  });

  if (!ssrcMsidLine) {
    throw new Error("a=ssrc line with msid information not found [track.id:".concat(track.id, "]"));
  } // Get the SSRC for RTX.


  (offerMediaObject.ssrcGroups || []).some(function (line) {
    if (line.semantics !== 'FID') {
      return false;
    }

    var ssrcs = line.ssrcs.split(/\s+/);

    if (Number(ssrcs[0]) === firstSsrc) {
      firstRtxSsrc = Number(ssrcs[1]);
      return true;
    } else {
      return false;
    }
  });
  var ssrcCnameLine = offerMediaObject.ssrcs.find(function (line) {
    return line.attribute === 'cname' && line.id === firstSsrc;
  });

  if (!ssrcCnameLine) {
    throw new Error("a=ssrc line with cname information not found [track.id:".concat(track.id, "]"));
  }

  var cname = ssrcCnameLine.value;
  var ssrcs = [];
  var rtxSsrcs = [];

  for (var i = 0; i < numStreams; ++i) {
    ssrcs.push(firstSsrc + i);

    if (firstRtxSsrc) {
      rtxSsrcs.push(firstRtxSsrc + i);
    }
  }

  offerMediaObject.ssrcGroups = offerMediaObject.ssrcGroups || [];
  offerMediaObject.ssrcs = offerMediaObject.ssrcs || [];
  offerMediaObject.ssrcGroups.push({
    semantics: 'SIM',
    ssrcs: ssrcs.join(' ')
  });

  for (var _i = 0; _i < ssrcs.length; ++_i) {
    var ssrc = ssrcs[_i];
    offerMediaObject.ssrcs.push({
      id: ssrc,
      attribute: 'cname',
      value: cname
    });
    offerMediaObject.ssrcs.push({
      id: ssrc,
      attribute: 'msid',
      value: "".concat(streamId, " ").concat(track.id)
    });
  }

  for (var _i2 = 0; _i2 < rtxSsrcs.length; ++_i2) {
    var _ssrc4 = ssrcs[_i2];
    var rtxSsrc = rtxSsrcs[_i2];
    offerMediaObject.ssrcs.push({
      id: rtxSsrc,
      attribute: 'cname',
      value: cname
    });
    offerMediaObject.ssrcs.push({
      id: rtxSsrc,
      attribute: 'msid',
      value: "".concat(streamId, " ").concat(track.id)
    });
    offerMediaObject.ssrcGroups.push({
      semantics: 'FID',
      ssrcs: "".concat(_ssrc4, " ").concat(rtxSsrc)
    });
  }
}

exports.addLegacySimulcast = addLegacySimulcast;